import type { ConsentCategories } from './segmentConsent';
import { hasSocialVendorConsent } from './segmentConsent';

declare global {
  interface Window {
    __ttclid?: string;
  }
}

export const TTCLID_STORAGE_KEY = 'ttclid';

const readStoredTtclid = (): string | null => {
  try {
    return window.sessionStorage.getItem(TTCLID_STORAGE_KEY);
  } catch (_) {
    return null;
  }
};

const writeStoredTtclid = (ttclid: string): void => {
  try {
    window.sessionStorage.setItem(TTCLID_STORAGE_KEY, ttclid);
  } catch (_) {
    // sessionStorage unavailable (private mode / disabled) — nothing to persist.
  }
};

const removeStoredTtclid = (): void => {
  try {
    window.sessionStorage.removeItem(TTCLID_STORAGE_KEY);
  } catch (_) {
    // sessionStorage unavailable (private mode / disabled) — nothing to clear.
  }
};

export const readTtclidFromUrl = (): string | null =>
  new URLSearchParams(window.location.search).get(TTCLID_STORAGE_KEY);

export const captureTtclid = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  const fromUrl = readTtclidFromUrl();
  if (fromUrl && !window.__ttclid) {
    window.__ttclid = fromUrl;
  }
};

export const handleTtclidConsent = (consent: ConsentCategories | undefined): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!hasSocialVendorConsent(consent, 'tiktok')) {
    removeStoredTtclid();
    return;
  }

  const pending = window.__ttclid ?? readTtclidFromUrl();
  if (!pending) {
    return;
  }

  if (readStoredTtclid()) {
    return;
  }

  writeStoredTtclid(pending);
};
